<template>
	<div>
		<b-overlay :show="isLoading">
			<b-table-simple sticky-header="60vh">
				<b-thead class="text-center">
					<b-tr>
						<b-th>Nombre</b-th>
						<b-th>Activo</b-th>
						<b-th>Fecha de Creación</b-th>
						<b-th>Acciones</b-th>
					</b-tr>
				</b-thead>
				<b-tbody class="text-center">
					<b-tr v-for="row in rows" :key="row.id">
						<b-td>{{ row.name }}</b-td>
						<b-td>
							<b-badge pill :variant="'light-' + (row.is_active ? 'success' : 'danger')">
								{{ row.is_active ? "SÍ" : "NO" }}
							</b-badge>
							<b-form-checkbox
								v-model="row.is_active"
								:true-value="1"
								:false-value="0"
								name="check-button"
								switch
								class="mt-1 text-center"
								@change="switchActive(row)"
								style="margin-left: 0.5rem"
							/>
						</b-td>
						<b-td>
							{{ row.created_at | myGlobalDayWithHour }}
						</b-td>
						<b-td>
							<div class="d-flex justify-content-center" style="gap: 0.5rem">
								<b-button size="sm" variant="flat-warning" @click="edit(row)">
									<feather-icon icon="EditIcon" />
								</b-button>
								<b-button size="sm" variant="flat-danger" @click="remove(row)">
									<feather-icon icon="TrashIcon" />
								</b-button>
							</div>
						</b-td>
					</b-tr>
					<b-tr v-if="rows.length == 0">
						<b-td colspan="4">
							<p class="mb-0">No hay registros por mostrar</p>
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
		<b-modal
			centered
			:title="creationModal && creationModal.id ? 'Editar Incidencia' : 'Registrar nueva incidencia'"
			v-model="creationModal.active"
			@hidden="handleHidden"
		>
			<b-overlay :show="creationModal.loading">
				<b-form-group label="Nombre">
					<b-form-input v-model="creationModal.name" />
				</b-form-group>
			</b-overlay>
			<template #modal-footer>
				<b-button variant="info" @click="edit()" v-if="creationModal.editing" :disabled="!!!creationModal.name">
					Editar
				</b-button>
				<b-button variant="success" @click="create" v-else :disabled="!!!creationModal.name">Guardar</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import PreparationIncidenceService from "@/views/brain/preparacion/services/preparation-incidence.service.js"
export default {
	props: {
		action: String,
	},
	data: () => ({
		isLoading: false,
		rows: [],
		creationModal: {
			active: false,
			id: null,
			name: "",
			status: null,
			loading: false,
			editing: false,
		},
	}),
	methods: {
		handleHidden() {
			this.creationModal = { active: false, id: null, name: "", status: null, loading: false, editing: false }
			this.$emit("actionDone")
		},
		async getRows() {
			this.isLoading = true
			const { data } = await PreparationIncidenceService.getIncidences()
			this.rows = data.map((incidence) => ({
				...incidence,
				is_active: incidence.is_active === 1 ? true : false,
			}))
			this.isLoading = false
		},
		async switchActive(row) {
			const { isConfirmed } = await this.showConfirmSwal({
				title: `¿Estás seguro de que quieres ${row.is_active ? "activar" : "desactivar"} a ${row.name}?`,
				text: "",
			})
			if (!isConfirmed) {
				row.is_active = !row.is_active
				return
			}
			try {
				const { message } = await PreparationIncidenceService.switchActive(row.id)
				this.getRows()
				this.showSuccessToast(message)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async create() {
			this.creationModal.loading = true
			const { isConfirmed } = await this.showConfirmSwal({
				text: `Se registrara la incidencia ${this.creationModal.name}`,
			})
			if (!isConfirmed) {
				this.handleHidden()
				return
			}
			try {
				const { status, message } = await PreparationIncidenceService.storeIncidence({
					name: this.creationModal.name,
				})
				if (status) {
					this.handleHidden()
					this.getRows()
					this.showToast("success", "top-right", "Razones", "SuccessIcon", message)
					return
				}
			} catch (error) {
				console.log(error)
			} finally {
				this.creationModal.loading = false
			}
		},
		async edit(row) {
			if (row) {
				this.creationModal.id = row.id
				this.creationModal.name = row.name
				this.creationModal.status = row.status_id
				this.creationModal.active = true
				this.creationModal.editing = true
				return
			}
			this.creationModal.loading = true
			if (!this.creationModal.name) return
			const { isConfirmed } = await this.showConfirmSwal()
			if (!isConfirmed) return
			try {
				const { message } = await PreparationIncidenceService.updateIncidence(this.creationModal.id, {
					name: this.creationModal.name,
				})
				this.getRows()
				this.handleHidden()
				this.showSuccessToast(message)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async remove(row) {
			this.isLoading = true
			const { isConfirmed } = await this.showConfirmSwal({ text: `Se eliminara la incidencia ${row.name}` })
			if (!isConfirmed) {
				this.isLoading = false
				return
			}
			await PreparationIncidenceService.deleteIncidence(row.id)
			this.isLoading = false
			this.getRows()
		},
	},
	created() {
		this.getRows()
	},
	watch: {
		action(val) {
			if (val == "create-incidence") {
				this.creationModal.active = !this.creationModal.active
			}
		},
	},
}
</script>
